import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../store/slices/authSlice';

const ProfileMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/login');
  };

  return (
    <li className="nav-item navbar-dropdown dropdown-user dropdown">
      <a className="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
        <div className="avatar avatar-online">
          <img src="/assets/img/avatars/1.png" alt="avatar" className="rounded-circle" />
        </div>
      </a>
      <ul className="dropdown-menu dropdown-menu-end">
        <li className="dropdown-header text-center">
          <h6 className="mb-0">{user?.name}</h6>
          <small className="text-muted">{user?.email}</small>
        </li>
        <li>
          <div className="dropdown-divider"></div>
        </li>
        <li>
          <div className="d-grid px-4 pt-2 pb-1">
            <button type="button" className="btn btn-sm btn-danger d-flex" onClick={handleLogout}>
              <small className="align-middle">Logout</small>
              <i className="ri-logout-box-r-line ms-2 ri-16px"></i>
            </button>
          </div>
        </li>
      </ul>
    </li>
  );
};

export default ProfileMenu;